import './App.css';
import Michi from './Components/Michi/Michi';
function App() {
  return (
   <Michi/>
  );
}

export default App;
